// This file is generated by scripts/generate-build-info.js
// Do not edit manually.

export const buildId = "dpl_H8kDxXULqCMCLhLpHcWSwBhfbAHk" as const;
export const builtAt = "2026-11-05T14:50:36.473Z" as const;
export const vercelEnv: string | null = "production";
export const gitCommitSha: string | null = "50b3dac0311924d78c43904b583131993bab0629";
export const deploymentId: string | null = "dpl_H8kDxXULqCMCLhLpHcWSwBhfbAHk";
